export default __webpack_public_path__ + "static/media/avatar-initials.efef4f60.svg";